import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import EditorialMarquee from "@/components/Marquee";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import About from "@/components/About";
import Featured from "@/components/Featured";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import LocationSec from "@/components/LocationSec";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import MobileBar from "@/components/MobileBar";
import BookingModal from "@/components/BookingModal";

function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const openBooking = useCallback(() => setBookingOpen(true), []);
  const closeBooking = useCallback(() => setBookingOpen(false), []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-cream text-ink font-sans antialiased">
      <Header onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />
        <TrustBar />
        <EditorialMarquee />
        <Services />
        <WhyUs />
        <About />
        <Featured />
        <Gallery />
        <Reviews />
        <LocationSec />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <MobileBar />
      <BookingModal open={bookingOpen} onClose={closeBooking} />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
